/* eslint-disable */
import _ from 'underscore';
import template from '@bingads-webui-static-legacy/bulk-edit/template/campaign/changeCashbackPercent.pug';
import viewModel from '@bingads-webui-static-legacy/bulk-edit/viewmodel/shared/changeCashbackPercent';
import BaseView from '@bingads-webui-static-legacy/bulk-edit/view/bulkEditJob';
import filterHelper from '@bingads-webui-static-legacy/bulk-edit/view/filterHelper';
import numericActionType from '@bingads-webui-static-legacy/schema/bulkEdit/numericActionType';
import decimalNumber from '@bingads-webui-component-legacy/humanize/decimal';
var i18n = window.globalLegacyI18n.get('module/extension/requirejs/i18n!global');
var formatBid = function (rows) {
  if (rows) {
    _.each(rows, function (value) {
      value.Entity = _.find(value.EntityKey, function (item) {
        return item.Key === 'CampaignName';
      });
      value.data = [];
      value.data.push({
        value: value.Entity && value.Entity.Value ? value.Entity.Value : '',
        isHtml: false
      });
      if (value.Changes && value.Changes.length) {
        var newValue = value.Changes[0].NewValue;
        var newValueText;
        if (+newValue === -1 || newValue === '') {
          newValueText = '-';
        } else {
          newValueText = decimalNumber.fromFloatToPercentString(value.Changes[0].NewValue, 2);
        }
        var originalValue = value.Changes[0].OriginalValue;
        value.data.push({
          value: originalValue === '' || +originalValue === -1 ? '-' : decimalNumber.fromFloatToPercentString(value.Changes[0].OriginalValue, 2),
          isHtml: false
        });
        value.data.push({
          value: newValueText,
          isHtml: false
        });
      } else {
        value.data.push({
          value: '',
          isHtml: false
        });
        value.data.push({
          value: '',
          isHtml: false
        });
      }
    });
  }
  return rows;
  ;
};
var view = BaseView.extend({
  initialize: function (options) {
    this.options = options || ({});
    BaseView.prototype.initialize.apply(this, arguments);
    this.template = template;
    this.entityType = options.entityType;
    this.ko_model = new viewModel({
      isCampaignBulkEdit: true,
      cashbackPercentDescription: i18n.getString('BulkEdit_Campaign_CashbackPercentMessage')
    });
  },
  render: function () {
    BaseView.prototype.render.apply(this, arguments);
    return this;
  },
  setAction: function () {
    this.model.set('Entity', 'Campaign');
    var oDataType = '#Model.NumericAction';
    var oDataProperty = 'CampaignCashback/Percent';
    var actionType = numericActionType.setAmount;
    var action = {
      Actions: [{
        '@odata.type': oDataType,
        Property: oDataProperty,
        ActionType: actionType,
        Value: this.ko_model.getCashbackPercentValueByAction()
      }]
    };
    this.model.set('BatchAction', action);
  },
  getIdFilter: function () {
    var filter = filterHelper.getIdFilter(this.grid, 'Campaign');
    return filter;
  },
  formatErrors: function (errors) {
    return formatBid(errors);
  },
  formatPreviewResults: function (results) {
    return formatBid(results);
  },
  getProgressText: function () {
    return i18n.getString('BulkEdit_Campaigns_ProgressText');
  }
});
export default view;

